import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const DraggingHandleIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6 9H18V11H6V9ZM6 13H18V15H6V13Z'
                fill='currentColor'
            />
        </>
    ),
})

DraggingHandleIcon.displayName = 'DraggingHandleIcon'
